<div class="date-container re-relative">
  <div class="re-form-item-container re-group">
    @if (shouldShowError()) {
      <div class="re-flex re-items-start re-justify-between re-mr-20 re-mb-5">
        <div
          class="error re-mr-20 re-mb-5"
          [id]="errorMessageId"
          aria-live="assertive"
          role="alert"
          [class.re-invisible]="focused"
        >
          {{requiredErrorText}}
        </div>
        @if (tooltipContent) {
          <div class="re-ml-10 re-flex-shrink-0">
            <bdo-inline-tooltip>
              <div [innerHTML]="tooltipContent"></div>
            </bdo-inline-tooltip>
          </div>
        }
      </div>
    } @else {
      <div class="re-flex re-items-start re-justify-between re-mr-20 md:re-mr-0 re-mb-5">
        <label
          [for]="datePickerId"
          class="animated fadeInUp re-block"
          [class.re-invisible]="!form.get('selectedDate').value"
        >
          {{labelText}}
        </label>
        @if (tooltipContent) {
          <div class="re-ml-10 re-flex-shrink-0">
            <bdo-inline-tooltip>
              <div [innerHTML]="tooltipContent"></div>
            </bdo-inline-tooltip>
          </div>
        }
      </div>
    }
    <div class="re-relative">
      <input class="re-truncate"
        name="date"
        [id]="datePickerId"
        type="text"
        matInput
        readonly
        [formControl]="$any(form.get('selectedDate'))"
        [placeholder]="labelText"
        [required]="required"
        [min]="minDateForChanges"
        [max]="maxDateForChanges"
        [autocomplete]="'new-password'"
        [matDatepicker]="$any(picker)"
        [attr.aria-invalid]="shouldShowError() ? 'true' : 'false'"
        [attr.aria-describedby]="shouldShowError() ? errorMessageId : null"
        (click)="picker.open()"
        (focusin)="picker.open()"
        (dateChange)="onDateChange($event)">
      <mat-datepicker #picker [calendarHeaderComponent]="customHeader"
        (opened)="datepickerOpen = true"
        (closed)="datepickerOpen = false"
      ></mat-datepicker>
      <svg-icon src="assets/icons/wizard_steps/calendar.svg"
        class="calendar__icon re-w-30 group-hover:re-text-secondary-hover bdo-date-icon"
        [ngClass]="{ 'opened': datepickerOpen }"
      ></svg-icon>
    </div>
  </div>
</div>
